import { BasicClient } from '@/utils/httpClient'
export default class Company {
  client: BasicClient
  constructor() {
    this.client = new BasicClient()
  }

  getTemplate(idEmail) {
    const url = `/v2/company-management/custom-template`
    return this.client.exec(url, 'GET', {template:idEmail})
  }

  postTemplate(params) {
    const {json,template} = params
    const url = `/v2/company-management/custom-template`
    return this.client.exec(url, 'POST',{template:template,json:json})
  } 

  getDefaultTemplate(idEmail) {
    const url = `/v2/company-management/default-template`
    return this.client.exec(url, 'GET',{template:idEmail})
  }

  getCategoryTemplate() {
    return this.client.exec('/v2/company-management/templates-categories', 'GET')
  }

  postCompanyImage(params) {
    return this.client.exec(`/v2/company-management/gallery`, 'POST', params, true)
  }

  getCompanyGallery() {
    return this.client.exec('/v2/company-management/gallery', 'GET')
  }
}
